import React, { useState, useEffect } from "react";
import CircularProgress from "@material-ui/core/CircularProgress/CircularProgress";
import MapController from "../map";
import gql from "graphql-tag";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import client from "../../lib/apollo";
import _ from "lodash";
import {
  addInitialContainersCount as aicc,
  clearState as cs
} from "../data/ducks";

const queryContainers = gql`
  query($layer: ID!) {
    containersByLayer(layer: $layer) {
      id
      layer
      name
    }
  }
`;

const MapInitialLoader = ({ addInitialContainersCount, clearState, layer }) => {
  const [state, setState] = useState({
    data: [],
    loading: false,
    error: null,
    lastLayer: ""
  });

  useEffect(() => {
    const fetchData = async () => {
      if(state.lastLayer !== layer && state.lastLayer !== ""){
        setState({
          loading: false,
          data: [],
          lastLayer: ""
        });
      }
      if (state.lastLayer !== layer && layer !== "") {
        clearState();
        try {
          const containersResponse = await client.query({
            query: queryContainers,
            variables: { layer: layer }
          });
          const { containersByLayer } = containersResponse.data;
          addInitialContainersCount(_.size(containersByLayer));
          const containersUrl = containersByLayer.map(container => {
            return {
              url: `https://s3.amazonaws.com/vgde-resources/${
                container.id
              }-topojson.json.gz`,
              id: container.id
            };
          });
          setState({
            loading: false,
            data: containersUrl,
            lastLayer: layer
          });
        } catch (error) {
          setState({
            loading: false,
            error
          });
        }
      }
    };
    fetchData();
  });

  const { loading, error, data } = state;
  
  if (loading) {
    return <CircularProgress />;
  } else if (error) {
    return "Error cargando datos";
  } else {
    return (
      <MapController
        center={{ lon: -75.6182306, lat: 6.2388487 }}
        zoom={6}
        vectorLayers={data}
      />
    );
  }
};

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    { addInitialContainersCount: aicc, clearState: cs },
    dispatch
  );
}

function mapStateToProps({ filters }) {
  return {
    layer: filters.get("layer")
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(MapInitialLoader);



// WEBPACK FOOTER //
// ./src/components/initialLoader/index.js